"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientCultureProvider = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _contexts = require("../contexts");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Client-side culture settings provider.
 *
 * Stores selected language, culture settings, financial settings and timezome identification.
 *
 * Gets the culture settings itself using API calls and **requires API client provider as a parent**. For more information see README.
 *
 * @see {@link ClientCultureProviderProps} for the available props and options.
 * @example
  // basic usage
  import { ClientCultureProvider, type ClientCultureProviderProps } from '@ori/culture';
  import { ApiClientProvider } from '@ori/static-api-client-react';
  import { Suspense, type FC } from 'react';

  export const appRender: FC<ClientCultureProviderProps> = ({ language, tenant, options }) => (
    ...
      <Suspense>
        <ApiClientProvider
          baseUrl="https://api-static.oriflame.com/"
          // you can provide more props
        >
          <ClientCultureProvider
            language={language}
            tenant={tenant}
            options={options}
          >
            ...
              // Client App
            ...
          </ClientCultureProvider>
        </ApiClientProvider>
      </Suspense>
    ...
  );
 */
const ClientCultureProvider = ({
  children,
  tenant,
  language,
  options
}) => {
  const {
    data: cultureSettings
  } = (0, _staticApiClientReact.useGetTenantCulture)(tenant, {
    ...options,
    swr: {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: true,
      errorRetryCount: 3,
      ...options?.swr
    }
  });
  const value = (0, _react.useMemo)(() => {
    const {
      lang
    } = document.documentElement;
    return (0, _utils.cultureSettingsToCultureContext)(cultureSettings, language, lang);
  }, [cultureSettings, language]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.CultureProvider, {
    value: value,
    children: children
  });
};
exports.ClientCultureProvider = ClientCultureProvider;
//# sourceMappingURL=ClientCultureProvider.js.map